// 问卷调查
import { getTreatmentDayitemNext, dayitemStepsubmit, getTreatmentDayitem } from '@/api/dialogue'
import { Dialog } from 'vant';
import Router from '@/router'
export default {
  state: {
    header: '',
    stepId: '', // 主键id
    instanceId: '', // 
    caseStudyList: [], // 当前问卷list
    caseStudyDialogueList: [], // 结束时对话
    caseStudyEnd: false, // 问卷 是否 已结束
  },
  getters: {
  },
  mutations: {
    // 设置主id
    setStepId(state, payload) {
      state.stepId = payload;
    },
    // 设置instanceId
    setInstanceId(state, payload) {
      state.instanceId = payload;
    },
    // 设置标题
    setHeader(state, payload) {
      state.header = payload;
    },
    // 设置问卷list
    setCaseStudyList(state, payload) {
      state.caseStudyList = payload;
    },
    // 设置list
    setCaseStudyEnd(state, payload) {
      state.caseStudyEnd = payload;
    },
  },
  actions: {
    // 获取子任务历史
    async getCaseStudyList({ commit, dispatch }, payload) {
      try {
        const resData = await getTreatmentDayitem(payload);
        const useData = JSON.parse(resData[0].message);
        let questionsData = useData.step_data.questions;
        questionsData = questionsData.map(item => {
          return {
            title: item.qstContext.title,
            options: item.qstContext.options,
          }
        })
        commit('setStepId', useData.step_id);
        commit('setInstanceId', useData.step_data.instance_id);
        commit('setCaseStudyList', questionsData);
        if(useData.length === 0) {
          dispatch('getTreatmentDayitemNext', payload)
        }
        return useData;
      } catch (error) {
        console.log(error)
        return false;
      }
    },
    // 获取子任务下一项内容
    async getCaseStudyNext({ state, commit, rootState }, payload) {
      try {
        const resData = await getTreatmentDayitemNext(payload);
        const useData = resData;
        // 如果是答题类型
          if(useData.step_type === 'SYS_INFO') {
            Dialog({
              message: useData.step_data.content
            }).then(() => {
              Router.back()
            });
            return;
          }
        if(useData.step_type === 'survey_qst') {
          let questionsData = useData.step_data.questions;
          questionsData = questionsData.map(item => {
            return {
              code: item.code,
              type: item.qstContext.type,
              hidden: item.qstContext.hidden,
              title: item.qstContext.title,
              options: item.qstContext.options,
              selectVal: ''
            }
          })
          
          commit('setHeader', useData.step_data.header);
          commit('setStepId', useData.step_id);
          commit('setInstanceId', useData.step_data.instance_id);
          commit('setCaseStudyList', questionsData);
        } else if(useData.step_type === 'survey_report') {
          commit('setCaseStudyEnd', true);
        } else {
          let useList = [];
          useList = [
            ...state.caseStudyDialogueList,
            {
              ...resData,
              id: payload.id,
              step_id: resData.step_id,
              instance_id: resData.step_data.instance_id,
              type: rootState.itemTypeList[resData.step_type],
              item_type: resData.step_type,
              text: resData.step_data.content || '',
              confirmTxt: resData.step_data.confirm || '',
              cancelTxt: resData.step_data.cancel || '',
              cardMode: 'dialogue',
              isShowTime: true
            }
          ];
          commit('setCaseStudyDialogueList', useList);
        }
        return resData
      } catch (error) {
        console.log(error)
        return false;
      }
    },
    // 子任务提交
    async caseStudyStepsubmit({ state }, payload) {
      try {
        const params = {
          id: payload.id,
          step_id: state.stepId,
          step_data: {
            survey: {
              id: state.instanceId,
              surveyType: 2,
              qstList: state.caseStudyList.map((item) => {
                return {
                  qstCode: item.code,
                  answer: { val: item.selectVal}
                }
              })
            },
          },
        };
        const resData = await dayitemStepsubmit(params);
        console.log(resData);
        return resData;
      } catch (error) {
        console.log(error);
        return false;
      }
    },
  }
}
